<mat-form-field>
  <mat-label>{{label}}</mat-label>

  <input matInput
    [errorStateMatcher]="errorStateMatcher"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    type="number"
    (input)="onChange(+$event.target.value)"
    (blur)="onTouched()">

    <mat-autocomplete #auto="matAutocomplete"
      (optionSelected)="onChange($event.option.value)">

      @for (value of options; track value) {
        <mat-option [value]="value">
          {{value === 0 ? 'Upon issue (0 days)' : (value + ' days')}}
        </mat-option>
      }
    </mat-autocomplete>

    <span matSuffix class="pr-10">days</span>

    <!-- Show control errors -->
    <mat-error>
      <app-validation-error [errors]="ngControl.errors"></app-validation-error>
    </mat-error>
  </mat-form-field>
